import { questionTypes } from "../../constants/Survey";

export default {
  mapped(state) {
    let survey = JSON.parse(JSON.stringify(state));

    for (let cIndex = 0; cIndex < survey.categories.length; cIndex++) {
      for (
        let qIndex = 0;
        qIndex < survey.categories[cIndex].questions.length;
        qIndex++
      ) {
        let question = survey.categories[cIndex].questions[qIndex];
        switch (question.type) {
          case questionTypes.table: {
            question.key = question.mappingKey;
            question.options = question.options.map(x => {
              x.value = x.mappingValue;
              return x;
            });

            question.children = question.children.map(x => {
              x.key = x.mappingKey;
              return x;
            });
            break;
          }
          case questionTypes.radio: {
            question.key = question.mappingKey;
            question.options = question.options.map(x => {
              x.value = x.mappingValue;
              return x;
            });
            break;
          }
        }
      }
    }

    return survey;
  }
};
